<div class="order-task-detail-container m-2">

    <div class="overflow-x-auto table-container mat-elevation-z8">
        <table mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="name-column">
                    <span> {{'ORDERMANAGEMENT.MANAGEORDERS.Name' | translate}} </span>
                    <span class="search-form-wrapper" style="display: inline-block;margin-left: 5px">
                        <span class="search-form">
                            <mat-icon matPrefix class="material-icons search">search</mat-icon>
                            <input style="width: 160px;height:40px" (keyup)="onKeyUp(searchBox.value)" #searchBox
                                [(ngModel)]="search" mat-input placeholder="{{'ORDERMANAGEMENT.SEARCH'| translate}}" />
                            <mat-icon *ngIf="this.search !== '' " class="material-icons clear"
                                (click)="resetSearch()">clear</mat-icon>
                        </span>
                    </span>
                </th>
                <td mat-cell *matCellDef="let data" class="name-column">
                    <button mat-icon-button [style.visibility]="!data.expandable ? 'hidden' : ''"
                        [style.marginLeft.px]="data.level * 32" (click)="treeControl.toggle(data)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <span [matTooltip]="data.name" >
                        {{ data.name }}
                    </span>
                </td>
            </ng-container>


            <ng-container matColumnDef="qty">
                <th mat-header-cell *matHeaderCellDef class="qty-column"> {{'ORDERMANAGEMENT.MANAGEORDERS.Qty' |
                    translate}} </th>
                <td mat-cell *matCellDef="let data" class="qty-column">
                    <span *ngIf="!data.level">{{data.qty}}</span>

                </td>
            </ng-container>


            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="status-column"> {{'ExecuteOrder.TaskStatus' |
                    translate}} </th>
                <td mat-cell *matCellDef="let data" class="status-column">
                    <ng-container *ngIf="data.selectEnabled">

                        <span *ngIf="data?.status === executeOrderStatus.NotStarted"
                            class="btn-style table-btn theme-line-btn sm-btn">
                            {{'ExecuteOrder.NotStarted' | translate}}
                        </span>
                        <span *ngIf="data?.status === executeOrderStatus.InProgress"
                            class="btn-style in-progress label-btn sm-btn table-btn">
                            {{'ExecuteOrder.InProgress' | translate}}
                        </span>
                        <span *ngIf="data?.status === executeOrderStatus.Completed"
                            class="btn-style active abel-btn sm-btn table-btn">
                            {{'ExecuteOrder.Completed' | translate}}
                        </span>
                        <span *ngIf="data?.status === executeOrderStatus.Assigned"
                            class="btn-style active abel-btn sm-btn table-btn">
                            {{'ExecuteOrder.Assigned' | translate}}
                        </span>
                        <span *ngIf="data?.status === executeOrderStatus.Planned"
                            class="btn-style table-btn theme-line-btn sm-btn">
                            {{'ExecuteOrder.Planned' | translate}}
                        </span>
                    </ng-container>
                </td>
            </ng-container>





            <ng-container matColumnDef="etc">
                <th mat-header-cell *matHeaderCellDef class="etc-column"> {{'ORDERMANAGEMENT.MANAGEORDERS.ETC' |
                    translate}} </th>
                <td mat-cell *matCellDef="let data" class="etc-column">
                    <span *ngIf="((!data.level) || data.selectEnabled || data.customizeVisible)">{{(data.customize && data.hasChild) ? (data?.etcNewData?.time | customTimeDuration:data?.etcNewData?.type):
                        (data?.expectedTimeToDeliver?.time | customTimeDuration:data?.expectedTimeToDeliver?.type)}}</span>
                </td>
            </ng-container>




            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
            </tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
        <div *ngIf="dataSource?.data?.length == 0" class="no-record text-center mt-15">
            {{'TABLE.No_record_found' | translate}} </div>
    </div>
    <div class="form-footer">
        <div class="step-form-bottom">
            <div>
                <button routerLink="/manage-order" class="btn-style red-line-btn" type="button">{{'GENERAL.Cancel' |
                    translate}}</button>
            </div>
            <div>




            </div>
        </div>
    </div>
</div>